export default (state) => {
    return state.policy;
}



// WEBPACK FOOTER //
// ./src/ReduxRequests/State/policyState.ts